import React from "react";
import "../projects.css";
import Timeline from "../timeline/juzDelightTimeline";
import "bootstrap/dist/css/bootstrap.min.css";

function JuzDelights() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="/assets/projects/juz-delights.png"
          alt="Juz Delights Project"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Juz Delights</h1>
        <p className="project-subtitle">
          A website redesign for Juz Delights, a small business specializing in nutritious desserts and meals. They were transitioning from B2B to B2C sales and needed a site they could maintain independently.
        </p>
        <div className="badge-container">
          <span className="badge">UI/UX Design</span>
          <span className="badge">Prototyping</span>
          <span className="badge">User Research</span>
          <span className="badge">Figma</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">👥</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Led competitor research, designed low to high-fidelity prototypes, and ensured the site would be easy for a small business team to maintain without technical support.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Short sprint focused on understanding their B2C transition, analyzing competitors, and building a maintainable prototype.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Key Contributions</h3>
            <ul className="overview-list">
              <li>Competitor analysis and industry research</li>
              <li>Low to high-fidelity Figma prototypes</li>
              <li>Easy-to-update website builder solution</li>
              <li>B2C-focused user experience design</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">The Problem</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            Juz Delights needed to transition from B2B sales to a B2C model, but lacked an online presence that could reach health-conscious consumers. They needed a website that showcased their products while being simple enough for a small team to update regularly.
          </p>
          <p className="case-study-text">
            I conducted competitor analysis to understand industry standards, then designed prototypes that balanced visual appeal with practical content management. The final solution used a website builder that allowed straightforward updates without technical expertise.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Focused On</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">🔍</span>
                <div className="value-content">
                  <strong>Competitor Research</strong>
                  <span className="value-text">Analyzed industry standards to inform design decisions and user expectations.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎨</span>
                <div className="value-content">
                  <strong>Visual Design</strong>
                  <span className="value-text">Created low to high-fidelity prototypes that balanced aesthetics with usability.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">⚙️</span>
                <div className="value-content">
                  <strong>Easy Maintenance</strong>
                  <span className="value-text">Designed with a website builder approach so the team could update content independently.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="project-timeline-section">
        <Timeline />
      </div>
    </div>
  );
}

export default JuzDelights;
